import { useEffect, useState } from 'react';

import { Button } from '@/components/Shared/Button';
import { CustomModal } from '@/components/Shared/CustomModal';

const ToggleSwitch = ({ checked, onChange }) => (
  <label className="relative inline-flex items-center shrink-0 cursor-pointer">
    <input
      type="checkbox"
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      className="sr-only peer"
    />
    <div className="w-9 h-5 bg-neutral-dark3 rounded-full peer peer-checked:bg-black after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:size-4 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-full peer-checked:after:bg-secondary-lightMintGreen" />
  </label>
);

const PreferenceRow = ({ title, description, control }) => (
  <div className="flex items-start justify-between gap-4 p-4">
    <div className="flex flex-col gap-1">
      <p className="text-sm font-semibold font-baskervville text-black">{title}</p>
      <p className="text-xs font-outfit text-black/60">{description}</p>
    </div>
    {control}
  </div>
);

export const CookiePreferencesModal = ({
  open,
  functionalEnabled,
  advertisingEnabled,
  onClose,
  onSave,
}) => {
  const [functional, setFunctional] = useState(functionalEnabled);
  const [advertising, setAdvertising] = useState(advertisingEnabled);

  useEffect(() => {
    if (open) {
      setFunctional(functionalEnabled);
      setAdvertising(advertisingEnabled);
    }
  }, [open, functionalEnabled, advertisingEnabled]);

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Manage Consent Preferences"
      leftAligned={false}
      maxWidth="sm"
      height="max-content"
    >
      <div className="flex flex-col gap-6 px-4 pb-6 mt-4">
        <p className="text-sm font-outfit text-black/70">
          We use cookies to run this site. Required cookies are always on since the site can&apos;t
          work without them — you can choose whether the rest apply.
        </p>

        <div className="flex flex-col border rounded-lg divide-y divide-neutral-light4 border-neutral-dark3">
          <PreferenceRow
            title="Required Cookies"
            description="Necessary for basic site functionality — session, authentication, and security cookies."
            control={
              <span className="text-xs font-semibold uppercase font-outfit text-black/50 shrink-0">
                Always Active
              </span>
            }
          />

          <PreferenceRow
            title="Functional Cookies"
            description="Used to analyze site traffic and understand how the site is used."
            control={<ToggleSwitch checked={functional} onChange={setFunctional} />}
          />

          <PreferenceRow
            title="Advertising Cookies"
            description="Used to track activity across sites and personalize the ads you're shown."
            control={<ToggleSwitch checked={advertising} onChange={setAdvertising} />}
          />
        </div>

        <Button
          variant="contained"
          color="primary"
          radius="4px"
          padding="0.5rem 1.5rem"
          textColor="white"
          className="!font-baskervville !self-end"
          onClick={() => onSave({ functional, advertising })}
        >
          Save
        </Button>
      </div>
    </CustomModal>
  );
};
